import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "application-approval-request" }
const _hoisted_2 = { class: "mr-4 background-member mt-1" }
const _hoisted_3 = { class: "text-gray-600" }
const _hoisted_4 = { class: "background-member mr-4 mt-1" }
const _hoisted_5 = { class: "text-gray-600" }
const _hoisted_6 = { class: "background-member mr-4 mt-1" }
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = { class: "background-member mr-4 mt-1" }
const _hoisted_9 = { class: "text-gray-600" }
const _hoisted_10 = { class: "background-member mr-4 mt-1" }
const _hoisted_11 = { class: "text-gray-600" }
const _hoisted_12 = { class: "background-member mr-4 mt-1" }
const _hoisted_13 = { class: "text-gray-600" }
const _hoisted_14 = {
  key: 1,
  class: "background-member mr-4"
}
const _hoisted_15 = { class: "text-gray-600" }
const _hoisted_16 = { class: "background-member mr-4 mt-1" }
const _hoisted_17 = { class: "text-gray-600" }
const _hoisted_18 = {
  key: 3,
  class: "background-member"
}
const _hoisted_19 = { class: "text-gray-600" }
const _hoisted_20 = { class: "flex mb-4 items-center" }
const _hoisted_21 = { class: "text-base mr-6 w-24" }
const _hoisted_22 = { class: "value-member" }
const _hoisted_23 = { class: "flex mb-4 items-center" }
const _hoisted_24 = { class: "text-base mr-6 w-24" }
const _hoisted_25 = { class: "value-member" }
const _hoisted_26 = { class: "flex mb-4 items-center" }
const _hoisted_27 = { class: "text-base mr-6 w-24" }
const _hoisted_28 = { class: "value-member" }
const _hoisted_29 = { class: "flex mb-4 items-center" }
const _hoisted_30 = { class: "text-base mr-6 w-24" }
const _hoisted_31 = { class: "value-member" }
const _hoisted_32 = { class: "flex mb-4 items-center" }
const _hoisted_33 = { class: "text-base mr-6 w-24" }
const _hoisted_34 = { class: "value-member" }
const _hoisted_35 = { class: "flex mb-4 items-center" }
const _hoisted_36 = { class: "text-base mr-6 w-24" }
const _hoisted_37 = { class: "value-member" }
const _hoisted_38 = { class: "flex mb-4 items-center" }
const _hoisted_39 = { class: "text-base mr-6 w-24" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "flex mb-4 items-center" }
const _hoisted_42 = { class: "text-base mr-6 w-24" }
const _hoisted_43 = { class: "flex-1" }
const _hoisted_44 = { class: "application-approval-box flex mt-8 mb-4" }
const _hoisted_45 = { class: "application-table w-fit" }
const _hoisted_46 = { class: "p-2" }
const _hoisted_47 = { class: "input-application" }
const _hoisted_48 = { class: "flex" }
const _hoisted_49 = { class: "flex flex-col" }
const _hoisted_50 = { class: "text-xs" }
const _hoisted_51 = { class: "box-month whitespace-normal flex items-center justify-center mb-2" }
const _hoisted_52 = { class: "whitespace-normal font-size-24" }
const _hoisted_53 = { class: "box-day" }
const _hoisted_54 = { class: "box-tag flex justify-center items-center" }
const _hoisted_55 = { class: "p-2 w-full" }
const _hoisted_56 = { class: "flex items-center mb-2" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-user-circle font-size-32 mr-1" }, null, -1)
const _hoisted_58 = { class: "font-bold" }
const _hoisted_59 = { class: "text-xs" }
const _hoisted_60 = { class: "text-xs" }
const _hoisted_61 = { class: "flex items-center flex-col" }
const _hoisted_62 = { class: "text-sm" }
const _hoisted_63 = { class: "flex justify-center" }
const _hoisted_64 = { class: "text-sm text-center truncate-2-line" }
const _hoisted_65 = {
  key: 0,
  class: "w-full p-2 cell-scroll"
}
const _hoisted_66 = { class: "text-grey-999 mr-1" }
const _hoisted_67 = {
  key: 0,
  class: "text-grey-999"
}
const _hoisted_68 = {
  key: 1,
  class: "w-full pl-2"
}
const _hoisted_69 = { class: "text-sm flex" }
const _hoisted_70 = {
  key: 0,
  class: "text-xs mr-2 title-info"
}
const _hoisted_71 = { class: "text-xs" }
const _hoisted_72 = { class: "flex items-center" }
const _hoisted_73 = {
  key: 0,
  class: "text-xs mr-2 title-info"
}
const _hoisted_74 = { class: "text-xs" }
const _hoisted_75 = { class: "flex justify-center" }
const _hoisted_76 = {
  key: 0,
  class: "text-sm text-center truncate-5-line"
}
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 2 }
const _hoisted_79 = { class: "flex items-center w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Input = _resolveComponent("Input")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ApplicationSearchArea = _resolveComponent("ApplicationSearchArea")
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")
  const _component_PopupApproveAllForm = _resolveComponent("PopupApproveAllForm")
  const _component_PopupRejectAllForm = _resolveComponent("PopupRejectAllForm")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ApplicationSearchArea, {
        onClose: _ctx.closeSearchDetail,
        onReset: _ctx.resetSearchInput,
        onSearch: _ctx.searchMembers
      }, {
        compact: _withCtx(() => [
          _withDirectives(_createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.t('applicationDateFind')), 1),
            _createTextVNode(": " + _toDisplayString(_ctx.paramsSearchApplication.submission_date), 1)
          ], 512), [
            [_vShow, _ctx.paramsSearchApplication.submission_date]
          ]),
          _withDirectives(_createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.t('applicationTargetDate')), 1),
            _createTextVNode(": " + _toDisplayString(_ctx.paramsSearchApplication.target_date), 1)
          ], 512), [
            [_vShow, _ctx.paramsSearchApplication.target_date]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unitNames, (item) => {
            return (_openBlock(), _createBlock("div", { key: item }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('affiliationOrganization')), 1),
                _createTextVNode(" : " + _toDisplayString(item), 1)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unitNamesCheckin, (item) => {
            return (_openBlock(), _createBlock("div", { key: item }, [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('dailyAttendanceHeaders.organization')), 1),
                _createTextVNode(" : " + _toDisplayString(item), 1)
              ])
            ]))
          }), 128)),
          _withDirectives(_createVNode("div", _hoisted_10, [
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('fullName')), 1),
            _createTextVNode(": " + _toDisplayString(_ctx.paramsSearchApplication.employee_name), 1)
          ], 512), [
            [_vShow, _ctx.paramsSearchApplication.employee_name]
          ]),
          (
            _ctx.paramsSearchApplication.application_form_status.length <
            _ctx.listStatus.length
          )
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.paramsSearchApplication.application_form_status, (item) => {
                return (_openBlock(), _createBlock("div", { key: item }, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t('status')), 1),
                    _createTextVNode(": " + _toDisplayString(_ctx.listStatus.find((e) => e.value === item).label), 1)
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('status')), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.t('applicationApprovalContent.all')), 1)
              ])),
          (
            _ctx.paramsSearchApplication.application_define_id.length <
            _ctx.listDefine.length
          )
            ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.paramsSearchApplication.application_define_id, (item) => {
                return (_openBlock(), _createBlock("div", { key: item }, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.t('applicationType2')), 1),
                    _createTextVNode(": " + _toDisplayString(_ctx.listDefine.find((e) => e.value === item).label), 1)
                  ])
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (
            _ctx.paramsSearchApplication.application_define_id.length ===
            _ctx.listDefine.length
          )
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.t('applicationType2')), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.t('applicationApprovalContent.all')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        form: _withCtx(() => [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('applicationDateFind')), 1),
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_DatePicker, {
                format: "YYYY/MM/DD",
                modelValue: _ctx.paramsSearchApplication.submission_date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramsSearchApplication.submission_date = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('stampRegister.targetDate')), 1),
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_DatePicker, {
                format: "YYYY/MM/DD",
                modelValue: _ctx.paramsSearchApplication.target_date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paramsSearchApplication.target_date = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, _toDisplayString(_ctx.t('workingStyle')), 1),
            _createVNode("div", _hoisted_28, [
              _createVNode(_component_MultiSelect, {
                placeholder: _ctx.t('pleaseEnterTheWorkingStyle'),
                modelValue: _ctx.paramsSearchApplication.working_style_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramsSearchApplication.working_style_id = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, _toDisplayString(_ctx.t('affiliationOrganization')), 1),
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_MultiSelect, {
                options: _ctx.unitList,
                itemValue: "unit_id",
                itemText: "unit_name",
                placeholder: _ctx.t('pleaseEnterTheDepartment'),
                modelValue: _ctx.paramsSearchApplication.unit_ids,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.paramsSearchApplication.unit_ids = $event))
              }, null, 8, ["options", "placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('dailyAttendanceHeaders.organization')), 1),
            _createVNode("div", _hoisted_34, [
              _createVNode(_component_MultiSelect, {
                options: _ctx.unitList,
                itemValue: "unit_id",
                itemText: "unit_name",
                placeholder: _ctx.t('pleaseEnterTheDepartment'),
                modelValue: _ctx.paramsSearchApplication.checkin_unit_id,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.paramsSearchApplication.checkin_unit_id = $event))
              }, null, 8, ["options", "placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('fullName')), 1),
            _createVNode("div", _hoisted_37, [
              _createVNode(_component_Input, {
                placeholder: _ctx.t('pleaseEnterYourName'),
                modelValue: _ctx.paramsSearchApplication.employee_name,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.paramsSearchApplication.employee_name = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('status')), 1),
            _createVNode("div", _hoisted_40, [
              _createVNode(_component_Checkbox, {
                class: "mr-8",
                label: _ctx.t('applicationApprovalContent.all'),
                fontSize: 14,
                onClick: _ctx.checkAllStatus,
                modelValue: _ctx.checkAllSelectedStatus,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkAllSelectedStatus = $event))
              }, null, 8, ["label", "onClick", "modelValue"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                return (_openBlock(), _createBlock(_component_Checkbox, {
                  modelValue: _ctx.paramsSearchApplication.application_form_status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.paramsSearchApplication.application_form_status = $event)),
                  value: item.value,
                  label: item.label,
                  key: item,
                  class: "mr-6",
                  fontSize: 14
                }, null, 8, ["modelValue", "value", "label"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode("div", _hoisted_42, _toDisplayString(_ctx.t('applicationType2')), 1),
            _createVNode("div", _hoisted_43, [
              _createVNode(_component_Checkbox, {
                class: "mr-8",
                label: _ctx.t('applicationApprovalContent.all'),
                fontSize: 14,
                onClick: _ctx.checkAll,
                modelValue: _ctx.checkAllSelected,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkAllSelected = $event))
              }, null, 8, ["label", "onClick", "modelValue"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listDefine, (item) => {
                return (_openBlock(), _createBlock(_component_Checkbox, {
                  key: item,
                  class: "mr-8",
                  value: item.value,
                  label: item.label,
                  fontSize: 14,
                  modelValue: _ctx.paramsSearchApplication.application_define_id,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.paramsSearchApplication.application_define_id = $event))
                }, null, 8, ["value", "label", "modelValue"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "onReset", "onSearch"]),
      _createVNode("div", _hoisted_44, [
        _createVNode(_component_Button, {
          class: "mr-4",
          onClick: _ctx.approveAllApplication,
          disabled: _ctx.selectedData.length === 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('bulkApproval')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          class: "whitespace-no-wrap",
          variant: "danger",
          onClick: _ctx.rejectAllApplication,
          disabled: _ctx.selectedData.length === 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('bulkRemand')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _createVNode("div", _hoisted_45, [
        _createVNode(_component_Table, {
          headers: _ctx.applicationHeaders,
          data: _ctx.applicationData,
          fixedLeft: 3,
          modelValue: _ctx.selectedData,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedData = $event)),
          itemText: "id",
          initMaxHeight: 700,
          listDisabled: _ctx.listDisabled,
          "current-page": _ctx.paramsSearchApplication.page,
          "onUpdate:current-page": _cache[13] || (_cache[13] = ($event: any) => (_ctx.paramsSearchApplication.page = $event)),
          "record-total": _ctx.pagination.total,
          "items-per-pages": _ctx.paramsSearchApplication.number_per_page,
          "onUpdate:items-per-pages": _cache[14] || (_cache[14] = ($event: any) => (_ctx.paramsSearchApplication.number_per_page = $event)),
          "show-item-per-page": "",
          "is-pagination": "",
          onOnChangePage: _ctx.onChangePage,
          onChangeItemPerPage: _ctx.onChangeItemPerPage
        }, {
          "data-checkbox": _withCtx(({ dataRow }) => [
            _createVNode("div", {
              class: 
              dataRow.application_status === _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
              dataRow.application_status === _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
              dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                ? 'cursor-not-allowed'
                : ''
            
            }, [
              _createVNode(_component_Checkbox, {
                disabled: 
                dataRow.application_status ===
                  _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                dataRow.application_status ===
                  _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
              ,
                modelValue: _ctx.selectedData,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedData = $event)),
                value: dataRow.id
              }, null, 8, ["disabled", "modelValue", "value"])
            ], 2)
          ]),
          "data-approve": _withCtx(({ dataRow, index }) => [
            _createVNode("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _createVNode(_component_Input, {
                  disabled: 
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                  dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                ,
                  classes: "bg-gray",
                  placeholder: _ctx.t('enterPlaceAdministratorComment'),
                  modelValue: dataRow.reason,
                  "onUpdate:modelValue": ($event: any) => (dataRow.reason = $event)
                }, null, 8, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]),
              _createVNode("div", _hoisted_48, [
                _createVNode("div", {
                  class: ["w-1/2 h-8 mr-2", 
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                  dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                    ? 'cursor-not-allowed'
                    : ''
                ]
                }, [
                  _createVNode(_component_Button, {
                    disabled: 
                    dataRow.application_status ===
                      _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                    dataRow.application_status ===
                      _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                    dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                  ,
                    class: "w-full",
                    onClick: ($event: any) => (_ctx.approveForm(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('approve')), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ], 2),
                _createVNode("div", {
                  class: ["w-1/2 h-8", 
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                  dataRow.application_status ===
                    _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                  dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                    ? 'cursor-not-allowed'
                    : ''
                ]
                }, [
                  _createVNode(_component_Button, {
                    disabled: 
                    dataRow.application_status ===
                      _ctx.APPLICATION_STATUS_TYPE.FINISHED ||
                    dataRow.application_status ===
                      _ctx.APPLICATION_STATUS_TYPE.REJECTED ||
                    dataRow.enable_approval === _ctx.ENABLE_APPROVAL.DISABLE
                  ,
                    class: "w-full whitespace-no-wrap",
                    onClick: ($event: any) => (_ctx.rejectForm(index)),
                    variant: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('remandFind')), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ], 2)
              ])
            ])
          ]),
          "data-target_date": _withCtx(({ item, dataRow }) => [
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, _toDisplayString(_ctx.handleYear(item)), 1),
              _createVNode("div", _hoisted_51, [
                _createVNode("span", _hoisted_52, _toDisplayString(_ctx.formatDate(item, 'MM/DD')), 1),
                _createVNode("span", _hoisted_53, _toDisplayString(`（${_ctx.formatDate(item, 'dd')}）`), 1)
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode(_component_Button, {
                  variant: "outline-primary",
                  size: "small",
                  class: "w-24",
                  onClick: ($event: any) => (_ctx.handleTypeApplication(dataRow))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('applicationApprovalContent.detailApplication')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ]),
          "data-employee_name": _withCtx(({ dataRow }) => [
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _hoisted_57,
                _createVNode("div", _hoisted_58, _toDisplayString(dataRow.employee_name), 1)
              ]),
              _createVNode("div", _hoisted_59, _toDisplayString(dataRow.employee_unit_name), 1),
              _createVNode("div", _hoisted_60, _toDisplayString(dataRow.working_style_name), 1)
            ])
          ]),
          "data-submission_date": _withCtx(({ item }) => [
            _createVNode("div", _hoisted_61, [
              _createVNode("div", _hoisted_62, _toDisplayString(_ctx.formatDate(item, 'YYYY/MM/DD')), 1),
              _createVNode("div", null, _toDisplayString(_ctx.formatDate(item, 'HH:mm')), 1)
            ])
          ]),
          "data-application_type": _withCtx(({ dataRow }) => [
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, _toDisplayString(dataRow.application_type_name), 1)
            ])
          ]),
          "data-application_info": _withCtx(({ item, dataRow, index }) => [
            (
              dataRow.application_type ===
              _ctx.APPLICATION_TYPE.CHECK_TIME_APPLICATION
            )
              ? (_openBlock(), _createBlock("div", _hoisted_65, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.applicationCheckTimeInfo(
                dataRow.application_form_id
              ), (app, indexAppInfo) => {
                    return (_openBlock(), _createBlock("div", {
                      key: JSON.stringify(app),
                      class: "font-size-12 mb-0.5 truncate"
                    }, [
                      (indexAppInfo < 3 || _ctx.isSeeMore[index])
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("span", _hoisted_66, _toDisplayString(_ctx.displayCheckTimeType(app.check_time_type)), 1),
                            (app.is_delete)
                              ? (_openBlock(), _createBlock("span", _hoisted_67, " （" + _toDisplayString(_ctx.t('delete')) + "） ", 1))
                              : _createCommentVNode("", true),
                            _createVNode("span", null, _toDisplayString(_ctx.displayTimeFormat(app.time, 'HH:mm')) + ", " + _toDisplayString(app.unit_name), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (
                _ctx.isShowSeeMore(
                  _ctx.applicationCheckTimeInfo(dataRow.application_form_id)
                )
              )
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: "mt-2 text-light-blue font-size-12 cursor-pointer hover:opacity-75",
                        onClick: ($event: any) => (
                _ctx.onClickSeeMore(
                  _ctx.applicationCheckTimeInfo(dataRow.application_form_id),
                  index
                )
              )
                      }, _toDisplayString(_ctx.isSeeMore[index] ? _ctx.t('closeBtn') : _ctx.t('seeMore')), 9, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_68, [
                  _createVNode("div", _hoisted_69, [
                    (item?.wait_numbers)
                      ? (_openBlock(), _createBlock("div", _hoisted_70, _toDisplayString(_ctx.t('timeCardNew.numberOfWaits')), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_71, _toDisplayString(item?.wait_numbers), 1)
                  ]),
                  _createVNode("div", _hoisted_72, [
                    (item?.checkin_unit_name)
                      ? (_openBlock(), _createBlock("div", _hoisted_73, _toDisplayString(_ctx.t('attendanceOrganization')), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_74, _toDisplayString(item?.checkin_unit_name), 1)
                  ])
                ]))
          ]),
          "data-application_reason": _withCtx(({ dataRow }) => [
            _createVNode("div", _hoisted_75, [
              (dataRow.application_reason)
                ? (_openBlock(), _createBlock("div", _hoisted_76, _toDisplayString(dataRow.application_reason), 1))
                : (_openBlock(), _createBlock("div", _hoisted_77, "-"))
            ])
          ]),
          "data-next_approval_name": _withCtx(({ dataRow }) => [
            (dataRow.next_approval_name?.length)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "flex items-center truncate-5-line",
                  innerHTML: _ctx.nextApproval(dataRow.next_approval_name)
                }, null, 8, ["innerHTML"]))
              : (dataRow.next_role_name?.length)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: "flex items-center truncate-5-line",
                    innerHTML: _ctx.nextApproval(dataRow.next_role_name)
                  }, null, 8, ["innerHTML"]))
                : (_openBlock(), _createBlock("div", _hoisted_78, "-"))
          ]),
          "data-application_status": _withCtx(({ item }) => [
            _createVNode("div", _hoisted_79, [
              _createVNode("div", {
                class: ["circle", 
                _ctx.applicationStatusTypeList.find((e) => e.value === item).color
              ]
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.applicationStatusTypeList.find((e) => e.value === item).text), 1)
            ])
          ]),
          _: 1
        }, 8, ["headers", "data", "modelValue", "listDisabled", "current-page", "record-total", "items-per-pages", "onOnChangePage", "onChangeItemPerPage"])
      ])
    ]),
    (_ctx.isShowPopupApproveAllForm)
      ? (_openBlock(), _createBlock(_component_PopupApproveAllForm, {
          key: 0,
          modelValue: _ctx.isShowPopupApproveAllForm,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.isShowPopupApproveAllForm = $event)),
          onOnClose: _ctx.closeApproveAllForm,
          listIdHistory: _ctx.listIdHistory,
          onUpdateData: _ctx.updateDataApplication
        }, null, 8, ["modelValue", "onOnClose", "listIdHistory", "onUpdateData"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPopupRejectAllForm)
      ? (_openBlock(), _createBlock(_component_PopupRejectAllForm, {
          key: 1,
          modelValue: _ctx.isShowPopupRejectAllForm,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.isShowPopupRejectAllForm = $event)),
          listIdHistory: _ctx.listIdHistory,
          onOnClose: _ctx.closeRejectAllForm,
          onUpdateData: _ctx.updateDataApplication
        }, null, 8, ["modelValue", "listIdHistory", "onOnClose", "onUpdateData"]))
      : _createCommentVNode("", true)
  ], 64))
}